module.exports = __webpack_public_path__ + "img/title1.498f3c99.png";